export function initTooltip($arr, noTooltips) {
    if (noTooltips === true || typeof $arr.tooltip !== 'function') {
        return;
    }

    function getPosTop(pos, $field) {
        if ($field.hasClass('editable-tag-input')) {
            $field = $field.parents('.editable-tags-container');
        }
        if (pos === 'bottom') {
            return $field.offset().top + $field.innerHeight();
        } else if (matchMedia('(min-width: 992px)').matches && (pos === 'left' || pos === 'right')) {
            return $field.offset().top + $field.innerHeight() / 2;
        } else {
            return $field.offset().top;
        }
    }

    $arr.tooltip({
        container: 'body',
        placement: function (tooltip, field) {
            const pos = field.getAttribute('data-placement');
            const $field = $(field);

            $.data(field, 'pos', {
                top: getPosTop(pos, $field),
                placement: pos,
            });

            $field.on('blur', (e) => {
                $(e.currentTarget).removeClass('scrolled');
            });

            const $label = (field.id && $('label[for="' + field.id + '"]')) || $();
            const $target = $label.hasClass('sr-only') ? $field : $label;

            if ($target.length) {
                Hop.formFn.initPosTooltip(this, tooltip, $target, $field);
            }

            return matchMedia('(min-width: 992px)').matches ? pos : 'top';
        },
        delay: {show: 500, hide: 300},
    });

    $arr.on('shown.bs.tooltip', function () {
        // eslint-disable-next-line no-invalid-this
        const el = this;
        const $tooltipTarget = $(el);
        const maxGap = 15;
        let gap = 0;
        const duration = $tooltipTarget.data('duration');

        function resetPosition() {
            if (!$tooltipTarget.length) {
                return;
            }
            const data = $.data($tooltipTarget[0], 'pos');
            if (!data || !data.pos) {
                return;
            }
            gap = data.top - $tooltipTarget.offset().top;
            if (gap > maxGap || gap < -maxGap) {
                $tooltipTarget.tooltip('hide');
                $tooltipTarget.addClass('scrolled');
            }
        }

        if ($tooltipTarget.parents('.modal').length && $tooltipTarget.hasClass('date-picker')) {
            $tooltipTarget.parents('.modal').scroll(() => {
                resetPosition();
            });
        } else if (!$tooltipTarget.hasClass('date-picker')) {
            $(window).on('scroll', () => {
                resetPosition();
            });
        }

        if (duration !== undefined && duration !== 'nolimit') {
            setTimeout(() => {
                $tooltipTarget.tooltip('hide');
                $tooltipTarget.addClass('scrolled');
            }, duration);
        }
    });

    $arr.on('hidden.bs.tooltip', function () {
        // eslint-disable-next-line no-invalid-this
        const el = this;
        const $this = $(el);
        if ($this.is(':focus') && $this.hasClass('date-picker') && !$this.hasClass('scrolled')) {
            setTimeout(() => {
                $this.tooltip('show');
            }, 50);
        }
    });
}
